import { connectedStore } from '../../store';
import selectors from '../selectors';

const getRedirects = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getRedirects(state);
};

export default getRedirects;
